<template>
  <div
    id="getPassword"
    :style="{ height: clientHeight + 'px' }"
    class="content self_c"
  >
    <headNav :back="true" title=" " :flag="true" />
    <div class="self_b">
      <div class="cell-content self-content">
        <p class="cell-title self_cell-title" slot="title">
          {{ window_c["Forget password"] }}
        </p>
        <div class="self_cell-group_title self_cell-group_title_1">
          {{ window_c["Mobile number"] }}
        </div>

        <div style="display:flex;">
          <area-code @change="selectCountry" />
          <van-field
            class="self_cell-input self_cell_input"
            v-model="form.phone"
            type="number"
            @input="phoneReg"
            :maxlength="phoneMaxLength"
            center
            clearable
            :placeholder="window_c['Enter your mobile number']"
          >
            <button
              class="cell-code self_bg_color"
              slot="button"
              :disabled="disabled"
              @click="getCode"
            >
              {{ code_text }}
            </button>
            <!-- <van-button :disabled="disabled" slot="button" @click="getCode" size="small" type="primary">{{code_text}}</van-button> -->
          </van-field>
        </div>
        <div class="self_cell-group_title">
          {{ window_c["Verification code"] }}
        </div>
        <van-field
          class="self_cell-input"
          maxlength="6"
          type="number"
          @input="yzmReg"
          v-model="form.authCode"
          :placeholder="window_c['Enter the verification code']"
        ></van-field>
      </div>

      <div class="cell-button" style="margin-top: auto;margin-bottom: 15px;">
        <p
          @click="nextStep"
          :style="
            !form.phone ||
            (form.phone &&
              (form.phone.length != 8 && form.phone.length != 11)) ||
            !form.authCode ||
            (form.authCode && form.authCode.length != 6) ||
            !smsCodeFlag
              ? 'background-color:#ccc;'
              : 'background-color:' + color_
          "
        >
          {{ window_c["Next"] }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import headNav from "@/components/headNav";

import { setPassword, sendSms, forgetPassword } from "@/js/api";
import areaCode from "@/components/areaCode.vue";

import myfn from "@/js/util";
import lang_ from "@/js/locales";
export default {
  data() {
    return {
      window_c: {
        "Forget password": "取回密碼",
        Next: "下一步",
        "Mobile number": "手機號碼",
        "Enter your mobile number": "輸入手機號碼",
        "Verification code": "驗證碼",
        "Enter the verification code": "請輸入驗證碼",
        "verification code": "獲取驗證碼",
        "Please enter your mobile number": "請輸入手機號",
        "Mobile number format error": "手機號碼格式錯誤",
        "Enter the verification code": "請輸入驗證碼"
      },
      clientHeight: 603,
      form: {
        phone: "",
        authCode: ""
      },
      code_text: "獲取驗證碼",
      disabled: false,
      smsCodeFlag: false,
      smsCodeClick: false, //是否點擊
      times: 60, // 重新獲取所需時間
      countDownTime: 0,
      color_: "",
      // 区号信息
      loginData: {
        countryData: [], // 城市 數據
        countryId: 1
      },
      phoneMaxLength: "8"
    };
  },
  created() {
    // let myTime = sessionStorage.myTimes;
    // if (myTime) {
    //   this.codeCountDown(myTime);
    // }
    myfn.selfSetIcon(); // 設置logo
    myfn.getBrand(this, () => {
      this.color_ = this.themeColor;
    });

    sessionStorage.removeItem("myTime");
  },
  mounted() {
    this.clientHeight = window.innerHeight || 603;
    this.init_lang();
  },
  methods: {
    // 修改当前选择区号id
    selectCountry(item) {
      this.loginData.countryId = item.id;
      if (item.id == 3) {
        this.phoneMaxLength = 11;
      } else {
        this.phoneMaxLength = 8;
      }
    },
    init_lang() {
      var window_c = this.window_c;
      window_c["Forget password"] = lang_.t("Forget password");
      window_c["Next"] = lang_.t("Next");
      window_c["Mobile number"] = lang_.t("Mobile number");
      window_c["Enter your mobile number"] = lang_.t(
        "Enter your mobile number"
      );
      window_c["Verification code"] = lang_.t("Verification code");
      window_c["Enter the verification code"] = lang_.t(
        "Enter the verification code"
      );
      this.code_text = lang_.t("verification code");
      window_c["Please enter your mobile number"] = lang_.t(
        "Please enter your mobile number"
      );
      window_c["Mobile number format error"] = lang_.t(
        "Mobile number format error"
      );
      window_c["Enter the verification code"] = lang_.t(
        "Enter the verification code"
      );
    },
    nextStep() {
      var form = this.form;
      var self = this;
      if (
        !form.phone ||
        (form.phone && (form.phone.length != 8 && form.phone.length != 11)) ||
        !form.authCode ||
        (form.authCode && form.authCode.length != 6) ||
        !this.smsCodeFlag
      ) {
        return;
      }
      if (!this.form.phone) {
        this.$toast(self.window_c["Please enter your mobile number"]);
      } else if (!regExpPhone.test(this.form.phone)) {
        this.$toast(self.window_c["Mobile number format error"]);
      } else if (!this.form.authCode) {
        this.$toast(self.window_c["Enter the verification code"]);
      } else {
        var data = {
          phone: this.form.phone,
          authCode: this.form.authCode,
          countryId: this.loginData.countryId
        };
        forgetPassword(data).then(res => {
          // console.log(res);
          // self.smsCodeFlag = false;
          if (res.code == "1") {
            this.$router.push({
              name: "update_password",
              params: {
                arg: myfn.setQueryParams([
                  myfn.getBrandId(this, 1),
                  this.form.phone,
                  data.authCode,
                  data.countryId
                ])
              }
            });
          }
        });
      }
    },
    // 獲取驗證碼
    getCode() {
      var self = this;
      if (self.smsCodeClick) {
        return;
      }
      if (this.form.phone.length != 11 && this.loginData.countryId == 3) {
        this.$toast(self.window_c["Mobile number format error"]);
        return;
      } else if (this.loginData.countryId != 3 && this.form.phone.length != 8) {
        this.$toast(self.window_c["Mobile number format error"]);
        return;
      }

      self.smsCodeClick = true;
      if (!this.form.phone) {
        this.$toast(self.window_c["Please enter your mobile number"]);
      } else if (!regExpPhone.test(this.form.phone)) {
        this.$toast(self.window_c["Mobile number format error"]);
      } else {
        self.$toast.loading({
          message: lang_.t("Loading"),
          forbidClick: true,
          duration: 0,
          loadingType: "spinner"
        });
        var data = {
          phone: this.form.phone,
          smsType: 1,
          type: 3,
          languageId: 4,
          countryId: this.loginData.countryId
        };
        sendSms(data)
          .then(res => {
            self.$toast.clear();
            self.smsCodeClick = false;
            if (res.code == "1") {
              self.smsCodeFlag = true;
              this.$toast(lang_.t("SMS sending"));
              var times = this.times;
              let endMsRes = new Date().getTime() + parseInt(times * 1000);
              sessionStorage.myTimes = JSON.stringify(endMsRes);
              this.codeCountDown(endMsRes, times);
              this.form.sms = res.sms;
            } else {
              this.$toast(res.errorMsg);
            }
          })
          .catch(err => {
            self.$toast.clear();
            self.$toast({
              message: lang_.t("Network instability, please try again")
            });
          });
      }
    },
    // 倒计时
    codeCountDown(endMsRes, times) {
      this.countDownTime = Math.ceil((endMsRes - new Date().getTime()) / 1000);
      if (parseInt(this.countDownTime) < 1) {
        return;
      }
      this.disabled = true;
      this.code_text = this.countDownTime + "s";
      let time = setTimeout(() => {
        this.countDownTime--;
        if (this.countDownTime < 1) {
          this.disabled = false;

          this.countDownTime = times;
          this.code_text = lang_.t("Regain validation code");
          clearTimeout(time);
        } else {
          this.codeCountDown(endMsRes);
        }
      }, 1000);
    },
    phoneReg(e) {
      var val = myfn.numberRegex(e);
      this.form.phone = val;
    },
    yzmReg(e) {
      var val = myfn.numberRegex(e);
      this.form.authCode = val;
    }
  },
  components: {
    headNav,
    areaCode
  }
};
</script>

<style lang="less">
.self_b {
  display: flex;
  flex-direction: column;
  height: 100%;
}
#getPassword .van-hairline-unset--top-bottom:after {
  border-width: 0;
}

#getPassword .van-cell-group__title {
  color: #000;
  padding: 14px 16px 0px;
}

#getPassword .van-cell__value,
#getPassword .van-cell__value--alone {
  border-bottom: 1px solid #999;
  padding-bottom: 8px;
}
</style>

<style scoped lang="less">
.self_cell_input {
  margin: 8px 0 !important;
  & /deep/ .van-cell__value {
    padding: 0 !important;
  }
}
#getPassword {
  background: #fff;
  display: flex;
  flex-direction: column;
}

.self-content {
  padding-bottom: 15px;
}

.cell-title {
  font-size: 50px;
  color: #333;
  margin: 50px 0;
}

.cell-code {
  outline: none;
  border: none;
  padding: 10px 20px;
  background-color: rgba(90, 187, 167, 1);
  color: #fff;
  border-radius: 8px;
  font-size: 15px;
  text-align: center;
}

.cell-code[disabled] {
  background-color: rgba(90, 187, 167, 0.5);
}

.cell-icon {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}

.cell-button p {
  width: calc(100% - 20px);
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #5abba7;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
  font-size: 17px;
}

.cell-button p:active {
  opacity: 0.8;
}

.cell-forget {
  color: #333;
  text-align: right;
}

.self_b {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/view/get_password.vue